import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';
const sendClickEvent = async (payload: {
  label: string;
}) => {
  const values = {
    ...payload,
    origin: 'web'
  };
  const authToken = getCookie(authKeys.authToken);
  const urlSendClick = !authToken ? apiConfig.routes.customer.sendClickPublic : apiConfig.routes.customer.sendClick;
  await api.post(urlSendClick, values);
};
export const useSendClickEvent = () => {
  return useMutation({
    mutationFn: sendClickEvent
  });
};